import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/h5/');

export default function HowPreparesSwiper({}: any) {
    const { useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const [swiper, setSwiper] = useState(null);
    const { locale } = useRouter();
    const handleReachEnd = () => {
        swiper.params.autoplay.reverseDirection = true;
    };

    const handleReachBeginning = () => {
        swiper.params.autoplay.reverseDirection = false;
    };

    const bannerMap: Record<string, string[]> = {
        us: [
            ['banner1.webp', 'banner1.jpg'],
            ['banner2.webp', 'banner2.jpg'],
            ['banner3.webp', 'banner3.jpg'],
        ],
        kr: [
            ['banner1_kr.webp', 'banner1_kr.jpg'],
            ['banner2_kr.webp', 'banner2_kr.jpg'],
            ['banner3_kr.webp', 'banner3_kr.jpg'],
        ],
    };
    const bannerObj = bannerMap[locale] || bannerMap.us;
    const bannerList = [
        { key: 1, img: bannerObj[0] },
        { key: 2, img: bannerObj[1] },
        { key: 3, img: bannerObj[2] },
    ];

    return (
        <div
            className={`${css.howPreparesSwiper} howPreparesSwiper GtmModuleData-section`}
            data-section-id={css.howPreparesSwiper}
            data-section-title={t('delta2.aniB_items_box2_msg1')}
        >
            <div className="h-box">
                <div className="h-title">
                    {t('delta2.aniB_items_box2_msg1')}
                    <br />
                    {t('delta2.aniB_items_box2_msg2')}
                </div>
                <div className="h-tip">{t('delta2.aniC_box1_msg1')}</div>
                <div className="h-sub">{t('delta2.aniC_box1_msg2')}</div>
                <div className="h-des" style={locale === 'jp' ? { fontSize: '0.15rem', lineHeight: '0.24rem' } : {}}>
                    {t('delta2.aniC_box1_msg3')}
                </div>
            </div>

            <div className="h-swiper">
                <Swiper
                    modules={[Autoplay]}
                    pagination={{
                        clickable: true,
                    }}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    preloadImages={false}
                    lazy={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    spaceBetween={26}
                    centeredSlides={true}
                    grabCursor={true}
                    onSwiper={(swiper: any) => setSwiper(swiper)}
                    onReachEnd={handleReachEnd}
                    onReachBeginning={handleReachBeginning}
                >
                    {bannerList?.map((item: any, k: number) => (
                        <SwiperSlide key={k}>
                            <EFPic name={item.img} loading="eager" />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
